export default "__VITE_ASSET__C83ztQmZ__"